import React from "react";

// component
import NotificationList from './NotificationList';

// mui
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';

// icons
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

// type
type PropsType = {
    roomId: number,
    roomName: string,
    userId: number,
}

function NotificationPane(props: PropsType) {
    const { roomId, roomName, userId } = props;

    return (
        <Accordion
            defaultExpanded={true}
            sx={{
                backgroundColor: "transparent",
                boxShadow: "unset",
                '&::before': {
                    display: "none",
                }
            }}
        >
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                sx={{
                    borderBottomWidth: 1,
                    borderBottomStyle: "solid",
                    borderBottomColor: (theme) => theme.palette.grey[300],
                }}
            >
                <Typography
                    variant="h5"
                    component="h1"
                    fontWeight="700"
                    gutterBottom
                    sx={{ mb: 0 }}
                >
                    {roomName}
                </Typography>
            </AccordionSummary>
            <AccordionDetails>
                <NotificationList
                    roomId={roomId}
                    userId={userId}
                />
            </AccordionDetails>
        </Accordion>
    );
}
export default React.memo(NotificationPane);